<template>
  <div class="body-section">
    <div>
      <div class="title-section" style="display: flex">
        <h1 class="title title-ruban">CAMPAGNES</h1>
        <div></div>
      </div>
      <div class="page-seperate"></div>
    </div>

    <div class="container">
      <div class="level mb-0" style="background-color: white; width: 100%">
        <!-- Left side -->
        <div class="level-right" style="width: 100%">
          <div class="level-item">
            <a class="is-info is-right" @click="openAddModal">
              <b-icon
                icon="briefcase-plus"
                type="is-info"
                title="Ajouter une campagne"
                class="mb-2 mt-2"
              >
              </b-icon>
            </a>
          </div>
          <div class="level-item">
            <a class="is-info is-right" @click="isSearchable = !isSearchable">
              <b-icon
                icon="magnify"
                title="Rechercher"
                type="is-info"
                class="mr-5 mb-2 mt-2"
              >
              </b-icon>
            </a>
          </div>
        </div>
      </div>
      <!-- collapse pour chaque campagnes -->
      <b-table
        class="card"
        animation="slide"
        :data="campaignsData"
        :striped="true"
        :default-sort="['dateCreation', 'desc']"
        style="width: 100%"
      >
        <b-table-column
          field="name"
          label="Désignation de la campagne"
          :searchable="isSearchable"
          sortable
          v-slot="props"
          >{{ props.row.name }}
        </b-table-column>
        <b-table-column
          field="client"
          label="Client commanditaire"
          :searchable="isSearchable"
          sortable
          v-slot="props"
          >{{ props.row.client }}
        </b-table-column>
        <b-table-column
          field="survey"
          label="Questionnaires"
          sortable
          :searchable="isSearchable"
          v-slot="props"
          >{{ props.row.surveys }}
        </b-table-column>
        <b-table-column
          field="answerings"
          label="Emails des répondants"
          sortable
          :searchable="isSearchable"
          v-slot="props"
          >{{
            props.row.answerings
              ? props.row.answerings.replaceAll(";", "; ")
              : ""
          }}
        </b-table-column>
        <b-table-column
          field="position"
          label="Postes des répondants"
          :searchable="isSearchable"
          sortable
          v-slot="props"
          >{{ removeLast(props.row.positions) }}
        </b-table-column>
        <b-table-column
          field="dateCreation"
          label="Date de création"
          sortable
          v-slot="props"
          >{{ dateCreation(props.row) }}
        </b-table-column>

        <b-table-column v-slot="props">
          <div style="display: flex">
            <a class="is-right" @click="openEditModal(props.row, props.row.id)">
              <b-icon
                icon="briefcase-edit"
                title="Modifier la campagne"
                type="is-info"
                class="mr-2"
              >
              </b-icon>
            </a>
            <a
              class="is-primary is-right"
              @click="removeCampaign(props.row, props.row.id)"
            >
              <b-icon
                icon="briefcase-remove"
                title="supprimer la campagne"
                type="is-info"
                class="mr-2"
              >
              </b-icon>
            </a>

            <router-link
              class="is-primary is-right"
              :to="'/campagne/' + props.row.id"
            >
              <b-icon
                icon="magnify"
                title="Détails de la campagne"
                type="is-info"
                class="mr-2"
              >
              </b-icon>
            </router-link>
          </div>
        </b-table-column>
      </b-table>

      <b-modal :active.sync="isEditModalActive" has-modal-card>
        <CampaignEditModal
          :campaign="selectedCampaign"
          :hasSameLabel="hasSameLabel"
          title="Modification d'une campagne"
          @edit-campaign="onEditCampaign"
        ></CampaignEditModal>
      </b-modal>

      <b-modal :active.sync="isAddModalActive" has-modal-card>
        <CampaignEditModal
          :hasSameLabel="hasSameLabel"
          title="Ajout d'une campagne"
          @edit-campaign="onAddCampaign"
        ></CampaignEditModal>
      </b-modal>
    </div>
  </div>
</template>

<script>
import CampaignEditModal from "@/components/SettingCampaign";
import apiService from "@/services/AxiosService.js";

import {
  AddCampaign,
  DeleteCampaign,
  EditCampaign,
} from "../services/dbService";
import moment from "moment";

export default {
  components: {
    CampaignEditModal,
  },
  data() {
    return {
      isOpen: 0,
      // modal
      selectedCampaign: {},
      selectedId: "",
      selectedCampaignOriginal: {},
      isEditModalActive: false,
      isAddModalActive: false,
      isSearchable: false,

      // gestion des erreur
      hasSameLabel: false,
      campaignsData: new Array(),
    };
  },
  props: {
    campaigns: {
      type: Object,
      required: true,
    },
  },

  mounted() {
    for (var key in this.campaigns) {
      this.campaigns[key].id = key; // console.log("key " + key + " has value " + myArray[key]);
    }
    this.campaignsData = Object.entries(this.campaigns).map((x) => x[1]);
  },

  methods: {
    dateCreation(campaign) {
      if (campaign.dateCreation != undefined)
        return moment(campaign.dateCreation.toDate()).format("DD/MM/YYYY");
      return "-";
    },
    removeLast(positions) {
      if (positions == undefined) {
        return "-";
      }
      return positions.slice(0, -1);
    },

    openEditModal(campaign, key) {
      this.selectedId = key;
      this.selectedCampaign = { ...campaign };
      this.selectedCampaign.surveys = campaign.surveys.split(";");
      this.selectedCampaignOriginal = { ...campaign };

      this.isEditModalActive = true;
    },
    openAddModal() {
      this.selectedCamapign = {
        idCampaign: 0,
        label: "",
      };
      this.isAddModalActive = true;
    },

    // campaigns

    onEditCampaign(campaignin) {
      var campaign = { ...campaignin };
      campaign.surveys = campaign.surveys.join(";");
      EditCampaign(
        this.selectedCampaignOriginal,
        { ...campaign },
        campaign.id,
        this.$store.state.user.uid
      )
        .then((campaignRes) => {
          campaignRes.id = campaign.id;
          this.$buefy.snackbar.open({
            message: "La campagne a été modifiée.",
            queue: false,
          });
          this.isAddModalActive = false;

          // remove already existing users
          this.selectedCampaignOriginal.answerings
            .split(";")
            .forEach((email) => {
              if (email != "" && email != ";") {
                campaign.answerings = campaign.answerings.replace(email, "");
              }
            });

          // défini les utilisateurs pouvant accéder à la campagn
          var resultSendMail = campaign.answerings
            .split(";")
            .find((x) => x != "" && x != ";");
          campaign.answerings.split(";").forEach(async (email) => {
            if (email != "") {
              resultSendMail =
                resultSendMail &&
                (await apiService.SendMailConnexion({
                  txtEmail: email,
                  txtFromSuEmail: this.$store.state.user.data.email,
                  txtKey: "turlututu",
                }));
            }
          });
          if (resultSendMail) {
            this.$buefy.snackbar.open({
              message:
                "Un email de connexion a été envoyé aux nouveaux répondants",
              queue: false,
            });
          }
          this.selectedCampaignOriginal = campaignRes;
          console.log(this.campaignsData);
          var index = this.campaignsData.findIndex(
            (x) => x.id === campaignRes.id
          );
          this.campaignsData[index] = { ...campaignRes };
          this.campaignsData = Object.assign([], this.campaignsData);
        })

        .catch((err) => {
          console.log(err);
          this.$buefy.snackbar.open({
            message: "Une erreur de saisie a été détectée.",
            type: "is-danger",
            queue: false,
          });
        });
    },
    onAddCampaign(campaign) {
      campaign.surveys = campaign.surveys.join(";");
      AddCampaign(
        campaign,
        this.$store.state.user.uid,
        this.$store.state.user.data.email
      )
        .then((campaignRes) => {
          this.$buefy.snackbar.open({
            message: "La campagne a été sauvegardée.",
            queue: false,
          });
          // défini les utilisateurs pouvant accéder à la campagn
          var resultSendMail = true;
          campaign.answerings.split(";").forEach(async (email) => {
            if (email != "") {
              resultSendMail =
                resultSendMail &&
                (await apiService.SendMailConnexion({
                  txtEmail: email,
                  txtFromSuEmail: this.$store.state.user.data.email,
                  txtKey: "turlututu",
                }));
            }
          });
          if (resultSendMail) {
            this.$buefy.snackbar.open({
              message: "Un email de connexion a été envoyé aux répondants",
              queue: false,
            });
          } else {
            this.$buefy.snackbar.open({
              message:
                "Une erreur est survenue lors de l'envoi des emails de connexion",
              type: "is-danger",
              queue: false,
            });
          }
          this.isAddModalActive = false;

          this.campaignsData.push(campaignRes);
        })
        .catch((err) => {
          console.log(err);
          this.$buefy.snackbar.open({
            message: "Une erreur de saisie a été détectée.",
            type: "is-danger",
            queue: false,
          });
        });
    },

    removeCampaign(campaign, key) {
      this.$buefy.dialog.confirm({
        title: `Supprimer la Campagne `,
        confirmText: "Supprimer",
        cancelText: "Annuler",
        type: "is-danger",
        hasIcon: true,
        message:
          "La campagne '" +
          campaign.name +
          "' va être supprimée" +
          ", êtes-vous sûr de vouloir continuer?",
        onConfirm: () => {
          DeleteCampaign(
            campaign,
            campaign.id,
            this.$store.state.user.uid
          ).then(() => {
            this.campaignsData = this.campaignsData.filter((x) => x.id != key);
            //  this.campaignsData = [...this.campaignsData];

            //   this.campaignsData = Object.assign({}, this.campaignsData);
            this.$buefy.snackbar.open({
              message: "La campagne a été supprimée",
              queue: false,
            });
          });
        },
      });
    },
  },
};
</script>

<style lang="css" scoped>
.is-primary {
  background-color: white !important;
}
</style>
